(function ($) {

	$(document).gp_ready(function () {
		$('form[data-form-id^="review-"]').on("submit_success", function (e, form_id) {
			$(document).trigger("close_modal", form_id)
		})
	})

})(jQuery);
